import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  TPatchNewHireWorkerStatusRequest,
  TPatchNewHireWorkerStatusResponse,
} from "./patchNewHireWorkerStatus.schema";

export const patchNewHireWorkerStatus = (axios: IAxiosInstance) => {
  return async (
    request: TPatchNewHireWorkerStatusRequest
  ): Promise<TPatchNewHireWorkerStatusResponse> => {
    const response =
      await axios.noRetry.patch<TPatchNewHireWorkerStatusResponse>(
        `/api/new-hire-reporting/workers/${request.worker_id}/status`,
        {
          record_id: request.record_id,
          status: request.status,
        }
      );
    return response.data;
  };
};
